import { DOM_CUSTOM_EVENTS } from './constants';

export default {
  mixins: [],

  data() {
    return {
      printCartCountChangedHandler: null
    };
  },

  methods: {
    bindCustomEventHandlers() {
      this.printCartCountChangedHandler = (e) => {
        const count = e?.detail?.count;
        if (typeof count !== 'number') return;
        this.$store.commit('printcart/SET_CART_COUNT', count);
      };
      document.addEventListener(
        DOM_CUSTOM_EVENTS.PRINT_CART_COUNT_CHANGED,
        this.printCartCountChangedHandler
      );
    }
  },

  beforeDestroy() {
    if (this.printCartCountChangedHandler) {
      document.removeEventListener(
        DOM_CUSTOM_EVENTS.PRINT_CART_COUNT_CHANGED,
        this.printCartCountChangedHandler
      );
    }
  }
};
